import { createSelector } from 'reselect'

const getStudentViewData = state => state.student

const studentAudioSelector = createSelector(
	[ getStudentViewData ],
	student => (
		{
			device_uid: student.device_uid,
			headers: student.headers,
		}
	)
)

export default studentAudioSelector
